<template>
  <div class="presupuesto-interno-comisiones-datos">
    <b-card header="Comisiones" class="presupuesto-totales">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showComisiones= !showComisiones">
        <i :class="showComisiones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="totales" class="mt-2" v-model="showComisiones">
        <b-table 
            class="registro"
            responsive="sm" 
            :items="vendedoresComisiones" 
            :fields="fields">
          <template v-slot:cell(vendedor)="data">
            <template v-if="data.item.comisionInterna">
              COMERCIAL
            </template>
            <template v-else>
              {{ data.item.vendedor }}
            </template>
          </template>
          <template v-slot:cell(pjeComision)="data">
            <template v-if="data.item.tipoComision == 1 || data.item.tipoComision == 3">
              {{ data.item.pjeComision | numero(2) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
          <template v-slot:cell(importe)="data">
            <template v-if="data.item.tipoComision == 2 || data.item.tipoComision == 3">
              {{ data.item.importe | moneda(presupuestoDatos.moneda) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
          <template v-slot:cell(montoComision)="data">
            {{ data.item.montoComision | moneda(presupuestoDatos.moneda) }}
          </template>
          <template v-slot:cell(montoCompras)="data">
            <template v-if="!data.item.comisionInterna">
              {{ data.item.montoCompras | moneda(presupuestoDatos.moneda) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
          <template v-slot:cell(montoCancelado)="data">
            {{ data.item.montoCancelado | moneda(presupuestoDatos.moneda) }}
          </template>
          <template v-slot:cell(saldo)="data">
            <template v-if="!data.item.comisionInterna">
              {{ data.item.saldo | moneda(presupuestoDatos.moneda) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
        </b-table>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'ComisionesDatos',
  data () {
    return {
      fields: [
        {
          key: 'vendedor',
          label: 'Vendedor'
        },
        {
          key: 'pjeComision',
          class: "text-right"
        },
        {
          key: 'importe',
          label: 'Importe Comision',
          class: "text-right"
        },
        {
          key: 'montoComision',
          class: "text-right"
        },
        {
          key: 'montoCompras',
          label: 'Monto Facturado',
          class: "text-right"
        },
        {
          key: 'montoCancelado',
          label: 'Monto Cancelado',
          class: "text-right"
        },
        {
          key: 'saldo',
          class: "text-right"
        },
      ],

      showComisiones: false,
      accesoComisiones: false
    }
  },
  computed: {
    ...mapFields([
      'vendedoresComisiones',
      'presupuestoDatos',
      'presupuestoTotalesDatos',
    ]),
    // vendedor() {
    //   if (!this.accesoComisiones) {
    //     return '';
    //   }

    //   if (this.vendedorComision) {
    //     if (this.vendedorComision.comisionInterna) {
    //       return 'COMERCIAL';
    //     } else if (this.vendedorComision.vendedor) {
    //       return this.vendedorComision.vendedor.trim();
    //     }
    //   }
    //   return '';
    // },
    // tipoComision() {
    //   if (this.vendedorComision) {
    //     if (this.vendedorComision.tipoComision) {
    //       return parseInt(this.vendedorComision.tipoComision);
    //     }
    //   }
    //   return 0;
    // },
    // pjeComision() {
    //   if (this.vendedorComision) {
    //     if (this.vendedorComision.pjeComision) {
    //       return parseFloat(this.vendedorComision.pjeComision);
    //     }
    //   }
    //   return 0;
    // },
    // montoBaseComision() {
    //   if (this.vendedorComision) {
    //     if (this.vendedorComision.montoBaseComision) {
    //       return parseFloat(this.vendedorComision.montoBaseComision);
    //     }
    //   }
    //   return 0;
    // },
    // totalComision() {
    //   if (this.vendedorComision) {
    //     return parseFloat(this.vendedorComision.montoComision);
    //   }
    //   return 0;
    // },
    // montoCompras() {
    //   if (this.vendedorComision) {
    //     return parseFloat(this.vendedorComision.montoCompras);
    //   }
    //   return 0;
    // },
    // saldoCancelado() {
    //   if (this.vendedorComision) {
    //     return this.vendedorComision.saldoCancelado;
    //   }
    //   return false;
    // },
    // fechaCancelacionSaldo() {
    //   if (this.vendedorComision) {
    //     return this.vendedorComision.fechaCancelacionSaldo;
    //   }
    //   return '1900-01-01';
    // },
    // usuarioCancelacionSaldo() {
    //   if (this.vendedorComision) {
    //     return this.vendedorComision.usuarioCancelacionSaldo;
    //   }
    //   return '';
    // },
    // saldo() {
    //   if (this.vendedorComision) {
    //     return parseFloat(this.vendedorComision.saldo);
    //   }
    //   return 0;
    // },
  },  
  created() {
    this.accesoComisiones = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosComisiones'));
  },
  methods: {
  },
}
</script>

<style>
  .presupuesto-interno-comisiones-datos table thead th {
    border-top: none;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="1"] {
    width: 28%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="2"] {
    width: 12%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="3"] {
    width: 12%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="4"] {
    width: 12%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="5"] {
    width: 12%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="6"] {
    width: 12%;
  }
  .presupuesto-interno-comisiones-datos .registro table td[aria-colindex="7"] {
    width: 12%;
  }

</style>
